<template>
  <div class="group-insight-strip">
    <div
      v-for="insight in insights"
      :key="insight.label"
      v-tippy="`${insight.label}: ${insight.helper}`"
      class="group-insight-card"
    >
      <Avatar
        :icon="insight.icon"
        :color="insight.color"
        size="lg"
        no-border
      />
      <div class="min-w-0">
        <div class="text-sm text-secondary">{{ insight.label }}</div>
        <div class="truncate text-xl font-semibold">{{ insight.value }}</div>
        <div
          v-if="insight.shortValue"
          class="text-sm text-secondary"
        >
          {{ insight.shortValue }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

// components
import Avatar from '@/components/avatar/Avatar.vue'

// types
import type { GroupDashboardInsight } from '@/types/domain/groupDashboard'

/** Insight cards rendered directly below the group dashboard hero. */
defineProps({
  insights: {
    type: Array as PropType<GroupDashboardInsight[]>,
    required: true
  }
})
</script>

<style scoped>
.group-insight-strip {
  display: grid;
  gap: var(--s-4);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.group-insight-card {
  display: flex;
  align-items: center;
  gap: var(--s-4);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 1.5rem;
  padding: var(--s-4);
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 18px 48px rgba(16, 24, 40, 0.06);
  backdrop-filter: blur(16px);
}

:global(body.dark .group-insight-card) {
  border-color: rgba(255, 255, 255, 0.08);
  background: rgba(17, 24, 39, 0.78);
}

@media (max-width: 768px) {
  .group-insight-strip {
    grid-template-columns: 1fr;
  }
}
</style>
